import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Organizations/Organization/Environments'
import { organizationTabsOverviewLayoutRoute } from 'pages/NWPlatform/Organizations/Organization/Routing'

type EnvironmentsSearch = {
  query?: string
}

export const environmentsOverviewRoute = createRoute({
  getParentRoute: () => organizationTabsOverviewLayoutRoute,
  path: `${StaticRouteParameter.ENVIRONMENTS}/`,
  component: Overview,
  validateSearch: (search: Record<string, unknown>): EnvironmentsSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
